import Tooltip from "./Tooltip";

interface WaferProgressIndicatorProps {
  backlog: number;
  scheduled: number;
  measured: number;
}

export function WaferProgressIndicator({
  backlog,
  scheduled,
  measured,
}: WaferProgressIndicatorProps) {
  const parts = [
    <span key="backlog" className={`font-medium ${backlog === 0 ? "text-muted-foreground" : ""}`}>
      B{backlog}
    </span>,
    <span
      key="scheduled"
      className={`font-medium ${scheduled === 0 ? "text-muted-foreground" : ""}`}
    >
      S{scheduled}
    </span>,
    <span key="measured" className={`font-medium ${measured === 0 ? "text-muted-foreground" : ""}`}>
      M{measured}
    </span>,
  ];

  // Create tooltip content - show all statuses including zeros
  const tooltipContent = (
    <div className="space-y-1">
      <div className="flex justify-between gap-2">
        <span>Backlog:</span>
        <span className="font-medium">
          {backlog} wafer{backlog !== 1 ? "s" : ""}
        </span>
      </div>
      <div className="flex justify-between gap-2">
        <span>Scheduled:</span>
        <span className="font-medium">
          {scheduled} wafer{scheduled !== 1 ? "s" : ""}
        </span>
      </div>
      <div className="flex justify-between gap-2">
        <span>Measured:</span>
        <span className="font-medium">
          {measured} wafer{measured !== 1 ? "s" : ""}
        </span>
      </div>
    </div>
  );

  return (
    <Tooltip
      content={tooltipContent}
      trigger={
        <span className="text-sm cursor-help">
          {parts.reduce((acc, part, index) => {
            if (index === 0) return [part];
            return [
              ...acc,
              // eslint-disable-next-line @eslint-react/no-array-index-key
              <span key={`sep-${index}`} className="text-muted-foreground mx-1">
                /
              </span>,
              part,
            ];
          }, [] as React.ReactNode[])}
        </span>
      }
    />
  );
}
